export type ContentTypeEventHandler = () => void;

// Shared service that currently holds methods for whiteboards version history
// This can be extended to support databases related work
export class ContentTypeEventService {
	private eventHandlers: Map<string, ContentTypeEventHandler>;

	constructor() {
		this.eventHandlers = new Map();
	}

	dispose() {
		this.eventHandlers = new Map();
	}

	/**
	 * This is called in Whiteboards to register the any event callbacks.
	 * Confluence FE can then use any of these events to trigger the whiteboard events.
	 */
	registerEventHandler(event: string, handler: ContentTypeEventHandler): void {
		this.eventHandlers.set(event, handler);
	}

	/**
	 * This is called in Whiteboards to unregister the any event callbacks.
	 */
	unregisterEventHandler(event: string): void {
		this.eventHandlers.delete(event);
	}

	/**
	 * Check if an event has any handlers registered to it
	 * @param event
	 */
	hasEventHandler(event: string): boolean {
		return this.eventHandlers.has(event);
	}

	/**
	 * Trigger an event in Whiteboards.
	 */
	triggerEvent(event: string): void {
		this.eventHandlers.get(event)?.();
	}
}
